import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  lang:any
  constructor() { }

  ngOnInit(): void {
    // this.lang = localStorage.getItem('language');
    // this.lang = this.lang.substring(1);
    // this.lang = this.lang.slice(0, -1);
  }

}
